import { render, staticRenderFns } from "./TeamRecords.vue?vue&type=template&id=28c13c92&scoped=true"
import script from "./TeamRecords.vue?vue&type=script&lang=ts"
export * from "./TeamRecords.vue?vue&type=script&lang=ts"
import style0 from "./TeamRecords.vue?vue&type=style&index=0&id=28c13c92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c13c92",
  null
  
)

export default component.exports